function optionswitch(myfilter) {
    //Populate the optionstore if the first time through
    if ($('#optionstore').text() == "") {
        $('option[class^="sub-"]').each(function() {
            var optvalue = $(this).val();
            var optclass = $(this).prop('class');
            var opttext = $(this).text();
            optionlist = $('#optionstore').text() + "@%" + optvalue + "@%" + optclass + "@%" + opttext;
            $('#optionstore').text(optionlist);
        });
    }

    //Delete everything
    $('option[class^="sub-"]').remove();

    // Put the filtered stuff back
    populateoption = rewriteoption(myfilter);
    $('#00N7F00000SLC7G').html(populateoption);
}

function rewriteoption(myfilter) {
    //Rewrite only the filtered stuff back into the option
    var options = $('#optionstore').text().split('@%');
    var resultgood = false;
    var myfilterclass = "sub-" + myfilter;
    var optionlisting = "";

    myfilterclass = (myfilter != "")?myfilterclass:"None";

    //First variable is always the value, second is always the class, third is always the text
    for (var i = 3; i < options.length; i = i + 3) {
        if (options[i - 1] == myfilterclass || myfilterclass == "None") {
            optionlisting = optionlisting + '<option value="' + options[i - 2] + '" class="' + options[i - 1] + '">' + options[i] + '</option>';
            resultgood = true;
        }
    }
    if (resultgood) {
        return optionlisting;
    }
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
$(document).ready(function(){
  var innerSliderLook = document.querySelectorAll(".innersliderLook");

  for (var i = 0, len = innerSliderLook.length; i < len; i++) {
    var innerSliderSingleLook = innerSliderLook[i];
    if (innerSliderSingleLook && innerSliderSingleLook.children.length > 0 && innerSliderSingleLook.parentNode && innerSliderSingleLook.parentNode.nodeType === 1) {
      try {
        var innerSliderInstance = tns({
          container: innerSliderSingleLook,
          items: 1,
          slideBy: 1,
          controls: true,
          nav: false,
          loop: false,
          mouseDrag: false,
          autoplay: false,
          gutter: 0
        });
      } catch (e) {
        console.error('Inner slider look init error:', e);
      }
    }
  }

  var uspCarousel = document.querySelector('.usp-carousel');
  if (uspCarousel && uspCarousel.children.length > 0 && uspCarousel.parentNode && uspCarousel.parentNode.nodeType === 1) {
    try {
      var uspSlider = tns({
        container: uspCarousel,
        items: 1,
        slideBy: 1,
        controls: false,
        nav: false,
        loop: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        speed: 600,
        center: true
      });
    } catch (e) {
      console.error('USP carousel slider init error:', e);
    }
  }
  var langArray = [];
  
  // Временно делаем vodiapicker видимым для получения корректного текста
  var $vodiapicker = $('.vodiapicker').first();
  var originalDisplay = $vodiapicker.css('display');
  $vodiapicker.css('display', 'block');
  
  $vodiapicker.find('option').each(function(){
    var img = $(this).attr("data-thumbnail");
    var text = $(this).text().trim();
    var value = $(this).val();
    var item = '<li><img src="'+ img +'" alt="" value="'+value+'"/><span>'+ text +'</span></li>';
    langArray.push(item);
    console.log('Language item created:', item); // Добавляем отладку
  });
  
  // Возвращаем оригинальное состояние display
  $vodiapicker.css('display', originalDisplay);

  console.log('Total language items:', langArray.length); // Добавляем отладку

  // Заполняем каждый .lang-select отдельно
  $('.lang-select').each(function() {
    var $langSelect = $(this);
    var $listContainer = $langSelect.find('.a');
    var $btnSelect = $langSelect.find('.btn-select');
    
    console.log('Found .lang-select:', $langSelect.length); // Добавляем отладку
    console.log('Found .a container:', $listContainer.length); // Добавляем отладку
    
    // Заполняем список языков для каждого селектора
    $listContainer.html(langArray.join(''));
    
    // Устанавливаем значение кнопки для каждого селектора
    if (langArray.length > 0) {
      $btnSelect.html(langArray[0]);
      var val = $vodiapicker.find('option').first().val();
      $btnSelect.attr('value', val);
    }
  });

  //change button stuff on click
  $('.a li').click(function(){
    var img = $(this).find('img').attr("src");
    var value = $(this).find('img').attr('value');
    var text = this.innerText;
    var item = '<img src="'+ img +'" alt="" /><span>'+ text +'</span>';
    
    // Обновляем только кнопку в том же .lang-select контейнере
    var $langSelect = $(this).closest('.lang-select');
    var $btnSelect = $langSelect.find('.btn-select');
    
    $btnSelect.html(item);
    $btnSelect.attr('value', value);
    $langSelect.find('.b').hide();
    
    // Убираем active класс если кнопка в menu-drawer
    if ($btnSelect.closest('.menu-drawer').length > 0) {
      $btnSelect.removeClass('active');
    }
    
    setTimeout(function(){
      window.location.href = value;
    }, 1000);

  });

  $(".btn-select").click(function(){
    var $button = $(this);
    var $langSelect = $button.closest('.lang-select');
    var $bElement = $langSelect.find('.b');
    
    // Проверяем, находится ли кнопка в menu-drawer
    var isInMenuDrawer = $button.closest('.menu-drawer').length > 0;
    
    // Переключаем отображение .b элемента
    $bElement.toggle();
    
    // Если кнопка в menu-drawer, переключаем класс active
    if (isInMenuDrawer) {
      var isVisible = $bElement.is(':visible');
      $button.toggleClass('active', isVisible);
    }
    
    // Закрываем все другие .b элементы в других .lang-select контейнерах
    $('.lang-select').not($langSelect).each(function() {
      var $otherLangSelect = $(this);
      var $otherBElement = $otherLangSelect.find('.b');
      var $otherButton = $otherLangSelect.find('.btn-select');
      
      $otherBElement.hide();
      
      // Убираем active класс с других кнопок в menu-drawer
      if ($otherButton.closest('.menu-drawer').length > 0) {
        $otherButton.removeClass('active');
      }
    });
  });
  
  // Закрываем языковой селектор при клике вне его области
  $(document).click(function(event) {
    if (!$(event.target).closest('.lang-select').length) {
      $('.lang-select .b').hide();
      
      // Убираем active класс со всех кнопок в menu-drawer
      $('.menu-drawer .lang-select .btn-select').removeClass('active');
    }
  });

  //check local storage for the lang
  var sessionLang = localStorage.getItem('lang');
  
  $('.lang-select').each(function() {
    var $langSelect = $(this);
    var $btnSelect = $langSelect.find('.btn-select');
    
    if (sessionLang) {
      //find an item with value of sessionLang
      var langIndex = -1;
      for (var i = 0; i < langArray.length; i++) {
        if (langArray[i].indexOf('value="' + sessionLang + '"') !== -1) {
          langIndex = i;
          break;
        }
      }
      if (langIndex !== -1) {
        $btnSelect.html(langArray[langIndex]);
        $btnSelect.attr('value', sessionLang);
      }
    } else {
      // По умолчанию используем первый элемент массива
      if (langArray.length > 0) {
        $btnSelect.html(langArray[0]);
        var $vodiapicker = $('.vodiapicker').first();
        $btnSelect.attr('value', $vodiapicker.find('option').first().val());
      }
    }
  });

})

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300))
  }
}
customElements.define('cart-note', CartNote);
